import { useEffect, useRef } from "react";

interface ContentEditableProps {
    initialContent: string;
    onContentChange: (content: string) => void;
    className?: string;
    style?: React.CSSProperties;
}

export const ContentEditable: React.FC<ContentEditableProps> = ({
    initialContent,
    onContentChange,
    className,
    style,
}) => {
    const editableRef = useRef<HTMLDivElement>(null);
    
    // Handle initial content and updates from parent
    useEffect(() => {
        if (editableRef.current && initialContent !== editableRef.current.innerHTML) {
            editableRef.current.innerHTML = initialContent || '';
        }
    }, [initialContent]);

    const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
        const content = e.currentTarget.innerHTML;
        onContentChange(content);
    };

    return (
        <div
            contentEditable
            ref={editableRef}
            className={className}
            style={style}
            onInput={handleInput}
            suppressContentEditableWarning={true}
        />
    );
};